import { useLocation } from "react-router-dom";
import ChatbotWidget from "@/components/feature/ChatbotWidget";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <>
      <title>Page Not Found | Perspective Therapy</title>
      <meta name="description" content="The page you are looking for does not exist. Browse our site map or return to the Perspective Therapy homepage." />
      <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <h1 className="text-xl md:text-2xl font-semibold mt-6">Page not found</h1>
          <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
          <p className="mt-4 text-lg md:text-xl text-gray-500">We couldn’t find the page you’re looking for.</p>
          <nav className="mt-8 flex flex-wrap justify-center gap-4" aria-label="Page not found navigation">
            <a className="rounded-full bg-[#8f4f5d] px-5 py-2.5 font-medium text-white hover:bg-[#743f4b]" href="/">
              Return home
            </a>
            <a className="rounded-full border border-[#8f4f5d] px-5 py-2.5 font-medium text-[#8f4f5d] hover:bg-[#f8eff1]" href="/clientportal">
              Client portal
            </a>
            <a className="rounded-full border border-[#8f4f5d] px-5 py-2.5 font-medium text-[#8f4f5d] hover:bg-[#f8eff1]" href="/staff">
              Staff portal
            </a>
          </nav>
        </div>
        <ChatbotWidget />
      </div>
    </>
  );
}
